import { Tooltip } from '@enter/core';
import styled from '@emotion/styled';
import { transparentize } from 'polished';
import React from 'react';
import { Variables } from '@enter/core/src/ui/base/variables';

const TagContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
`;

const Tag = styled.span`
    display: inline-block;
    color: ${Variables.ThemeLight.PrimaryInverted2};
    background-color: ${Variables.ThemeLight.PrimaryInverted9};
    border-radius: ${Variables.Rounded.large};
    padding: 2px 8px;
    font-size: 14px;
    white-space: nowrap;
`;

const EmptyState = styled.span`
    color: ${Variables.Colors.n50};
    font-style: italic;
    font-size: 12px;
`;

const TooltipContent = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    padding: 8px;
    max-width: 300px;
`;

interface ICategoryTagsProps {
    categories?: string[];
}

export const CategoryTags: React.FC<ICategoryTagsProps> = ({ categories }) => {
    if (!categories || categories.length === 0) {
        return <EmptyState>—</EmptyState>;
    }

    const MAX_VISIBLE_TAGS = 2;
    const visibleTags = categories.slice(0, MAX_VISIBLE_TAGS);
    const remainingCount = categories.length - MAX_VISIBLE_TAGS;
    const hasMore = remainingCount > 0;

    const tooltipContent = (
        <TooltipContent>
            {categories.map((item, index) => (
                <Tag key={`${item}-${index}`}>{item}</Tag>
            ))}
        </TooltipContent>
    );

    return (
        <Tooltip direction="top" size="medium" title={tooltipContent}>
            <TagContainer>
                {visibleTags.map((item, index) => (
                    <Tag key={`${item}-${index}`}>{item}</Tag>
                ))}
                {hasMore && <Tag>+{remainingCount}</Tag>}
            </TagContainer>
        </Tooltip>
    );
};

